import Vue from 'vue';
import {MLInstaller, MLCreate, MLanguage} from 'vue-multilanguage';
import engTranslate from '@/languages/eng'
import ruTranslate from '@/languages/ru'
import uaTranslate from '@/languages/ua'
import deTranslate from '@/languages/de'
import itTranslate from '@/languages/it'
import frTranslate from '@/languages/fr'
import spTranslate from '@/languages/sp'

Vue.use(MLInstaller);

const lang = navigator.language;
const initialLang = (function () {
    let vueLang = localStorage.getItem('vueml-lang')
    switch (vueLang) {
        case 'russia': {
            localStorage.setItem('vueml-lang', 'ru')
            break;
        }
        case 'ukraine': {
            localStorage.setItem('vueml-lang', 'uk')
            break;
        }
        case 'english': {
            localStorage.setItem('vueml-lang', 'en')
            break;
        }
        default: {
            localStorage.removeItem('vueml-lang')
            break;
        }
    }
    var lng = localStorage.getItem('lang')
    if(lng != 'ru'
        && lng != 'uk'
        && lng != 'en'
        && lng != 'de'
        && lng != 'it'
        && lng != 'fr'
        && lng != 'sp'
    ) {
        localStorage.removeItem('lang')
    }
    lng = localStorage.getItem('lang')
    if (lng) {
        return lng;
    } else if (lang.indexOf('ru') != -1) {
        return 'ru';
    } else if (lang.indexOf('uk') != -1) {
        return 'uk';
    } else if (lang.indexOf('de') != -1) {
        return 'de';
    } else if (lang.indexOf('it') != -1) {
        return 'it';
    } else if (lang.indexOf('fr') != -1) {
        return 'fr';
    } else if (lang.indexOf('es') != -1) {
        return 'sp';
    } else {
        return 'en';
    }
})();

export default new MLCreate({
    initial: initialLang,
    save: true,
    languages: [
        new MLanguage('en').create(engTranslate),
        new MLanguage('ru').create(ruTranslate),
        new MLanguage('uk').create(uaTranslate),
        new MLanguage('de').create(deTranslate),
        new MLanguage('it').create(itTranslate),
        new MLanguage('fr').create(frTranslate),
        new MLanguage('sp').create(spTranslate),
    ],
});
